import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Dropdown, Modal} from "react-bootstrap";
import { FaPlus, FaRegEdit, FaSearch, FaFilter, FaFileExport, FaFileImport } from "react-icons/fa";
import api from "../../services/api";
import { getCurrentUser, hasPerm, formataCNPJ } from '../../common/utils';
import Paginacao from '../../common/pagination';

class Clientes extends Component {
    constructor(props) {
        super(props);
        this.onChangeBusca = this.onChangeBusca.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaCliente = this.buscaCliente.bind(this);

        this.state = {
            listClientes: [],
            error: "",
            busca: "",
            page_numb: 1,
            loading: true,
            showModal: false,
        };
        
        // Bind de métodos
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this)
    }

    componentDidMount(){
        this.consultaClientes(this.state.busca, this.state.page_numb)
    }

    // Método para abrir o Modal
    handleShowModal() {
        this.setState({ showModal: true });
    }

    // Método para fechar o Modal
    handleCloseModal() {
        this.setState({ showModal: false });
    }

    // Método chamado quando um arquivo é selecionado
    handleFileChange(event) {
        const file = event.target.files[0];
        // Aqui você pode implementar o processamento do arquivo
        this.handleCloseModal(); // Opcional: feche o Modal após selecionar o arquivo
    }

    consultaClientes(busca, page_numb=1){

        const dados_user = getCurrentUser();

        api.get(`/pessoas/clientes/?nome=${busca}&page=${page_numb}&tipo_usuario=${dados_user['tipo_usuario']}`)
        .then(response => {
            this.setState({
                loading: false,
                error: "",
                listClientes: response.data
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar clientes, tente novamente.';

            if(error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response.status === 403){
                erro_msg = 'Você não tem permissão acessar essa área';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }

    renderRows = () => {
        if('results' in this.state.listClientes && this.state.listClientes.results.length > 0){
            return this.state.listClientes.results.map((item) =>
            <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.dados_pessoa.razao_social}</td>
                <td>{item.dados_pessoa.cpf_cnpj ? formataCNPJ(item.dados_pessoa.cpf_cnpj) : ''}</td>
                <td>{item.dados_pessoa.email}</td>
                <td>{item.dados_pessoa.telefone}</td>
                <td>{item.uuid}</td>
                <td>
                    {hasPerm('change_clientes') && (
                    <Button variant="light" href={"/clientes/edit/"+item.id} size="sm">
                        <FaRegEdit /> Editar
                    </Button>   
                    )} 
                </td>
            </tr>
            );
        }        

        return (
            <tr>
                <td colSpan={7}>Nenhum cliente cadastrado</td>
            </tr>
        );
    };

    onChangeBusca(e) {
        this.setState({
            busca: e.target.value
        });
    }

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaClientes(this.state.busca, num_page)
    };

    buscaCliente(e) {
        e.preventDefault();

        this.setState({
            loading: true,
        });
        
        this.consultaClientes(this.state.busca)
    };

    render() {
        if (!hasPerm('view_clientes')) {
            return <Navigate to='/sem-permissao' />
        }

        let dados_usuario = getCurrentUser();

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Clientes</h4>
                    </Col>
                    <Col sm={6} lg={6} className="text-end">
                        {hasPerm('add_clientes') && (
                        <Button variant="secondary" href="/clientes/add" className="mb-3" size="sm">
                            <FaPlus /> Adicionar Cliente
                        </Button>
                        )}
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Row>
                            <Col sm={12} lg={12} className="mb-3 d-flex justify-content-end">
                                <Dropdown className="d-inline">
                                    <Dropdown.Toggle variant="light" size="sm">
                                        <FaFilter /> Filtrar
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <div className="drop-filter">
                                            <Form method="get" onSubmit={this.buscaCliente}>
                                                <Row>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Nome</Form.Label>                                  
                                                            <Form.Control
                                                                type="text"
                                                                name="busca"
                                                                value={this.state.busca}
                                                                onChange={this.onChangeBusca}
                                                                placeholder="Nome do cliente"
                                                                aria-label="Nome do cliente"
                                                                aria-describedby="basic-addon2"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                <Button type="submit" variant="light" size="sm">
                                                    <FaSearch /> Filtrar
                                                </Button>
                                            </Form>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>

                                {/*<Button variant="light" className="ms-2" size="sm">
                                    <FaFileExport /> Exportar
                                </Button>*/}
                                {(dados_usuario['tipo_usuario'] == '' || dados_usuario['tipo_usuario'] == 'gestor') && hasPerm('add_clientes') && (
                                    <Button variant="light" className="ms-2" size="sm" onClick={this.handleShowModal}>
                                        <FaFileImport /> Importar Clientes
                                    </Button>
                                )}
                            </Col>
                        </Row>    

                        {/* Modal para importação de arquivo */}
                        <Modal show={this.state.showModal} onHide={this.handleCloseModal}>
                            <Modal.Header closeButton>
                                <Modal.Title>Importar Clientes</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form.Group>
                                    <Form.Label>Selecione um arquivo Excel para importar:</Form.Label>
                                    <Form.Control 
                                        type="file" 
                                        required={true}
                                        onChange={this.handleFileChange}
                                    />
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="" onClick={this.handleCloseModal}>
                                    Fechar
                                </Button>
                                <Button variant="secondary" >
                                    Importar
                                </Button>
                            </Modal.Footer>
                        </Modal> 

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Razão Social</th>
                                    <th>CNPJ</th>
                                    <th>E-mail</th>
                                    <th>Telefone</th>
                                    <th>UUID</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={7}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={7}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listClientes && this.state.listClientes.results.length > 0 && 
                            <Paginacao dados={this.state.listClientes} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(Clientes);